import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rate-package-select-dialog',
  templateUrl: './rate-package-select-dialog.component.html',
  styleUrls: ['./rate-package-select-dialog.component.css']
})
export class RatePackageSelectDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
